// src/components/CacheStamp.tsx
"use client";

import { useEffect } from "react";

type Variant = "page" | "layout";

type Props = {
  label: string;      // e.g. "page:about-us" or "layout"
  renderedAt: string; // ISO timestamp from server render
  variant?: Variant;
};

export default function CacheStamp({ label, renderedAt, variant = "page" }: Props) {
  useEffect(() => {
    const scope = variant.toUpperCase();
    console.log(`[ISR][${scope}] ${label} renderedAt: ${renderedAt}`);
  }, [label, renderedAt, variant]);

  // No UI output at all
  return null;
}
